import { ArrowLeftIcon, ArrowDownIcon } from '@heroicons/react/20/solid'
import { useTranslation } from 'react-i18next'
import { Badge } from 'components/badge'
import { GET_TRIP_INFO } from 'graphql/route/queries'
import { useParams } from 'react-router-dom'
import { useLazyQuery } from '@apollo/client'
import { useEffect, useState } from 'react'
import loadingImage from 'assets/images/boat-loading.gif'
import moment from 'moment'
import { customDateFormat, customTimeFormat } from 'utils/common'
import TripAlert from '../TripAlert'

export default function MetroTripDetails() {
    const { t } = useTranslation()
    const { id } = useParams()
    console.log('TRIP ID==============: ', id)
    console.log('TRIP ID: ', id)
    const [tripInfo, setTripInfo] = useState(null)

    const [getTripInfo, { loading: tripInfoLoading, error: tripInfoError }] = useLazyQuery(GET_TRIP_INFO, {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        onCompleted: data => {
            if (data.getBoatRouteTrip.success && data.getBoatRouteTrip.code === '200') {
                setTripInfo(data.getBoatRouteTrip.trip)
            }
        },
    })
    useEffect(() => {
        console.log('Search boat===')
        getTripDetail()
    }, [id])
    const getTripDetail = () => {
        getTripInfo({
            variables: {
                tripId: id,
            },
        })
    }

    return (
        <>
            <div className="mb-6 flex justify-normal items-center">
                <button
                    onClick={() => {
                        window.history.back()
                    }}
                    type="button"
                    className="inline-flex items-center gap-x-1 rounded-md text-sm text-gray-600"
                >
                    <ArrowLeftIcon aria-hidden="true" className="-ml-0.5 h-5 w-4 rtl:rotate-180" />
                    {t('Back')}
                </button>
                <h3 className="text-lg font-semibold leading-7 text-primary ps-2 pb-1">
                    {' '}
                    {t('Trip schedule details')}
                </h3>
            </div>
            {tripInfoLoading && (
                <div className="flex flex-col justify-center items-center bg-white h-96 mt-16">
                    <img alt="logo" src={loadingImage} className="w-[250px]" />
                    <p className="pt-3 text-primary font-semibold">{t('Loading, please wait...')}</p>
                </div>
            )}
            {tripInfoError && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('Failed to fetch trip details!')}</div>
                </div>
            )}
            {!tripInfoLoading && !tripInfoError && tripInfo === null && (
                <div className="flex justify-center items-center bg-white py-5">
                    <div className="text-lg text-center">{t('No trip details found!')}</div>
                </div>
            )}
            {!tripInfoLoading && !tripInfoError && tripInfo && (
                <>
                    <div className="mt-2 mb-4">
                        <TripAlert />
                    </div>
                    <div className="flex flex-wrap items-end justify-between gap-4">
                        <div className="max-sm:w-full sm:flex-1">
                            <div className="md:flex md:items-center md:justify-between md:space-x-5">
                                <div className="flex items-start space-x-5">
                                    <div className="flex-shrink-0">
                                        <div className="relative">
                                            <div className="w-16 h-16 bg-gray-50 p-4 flex justify-center items-center">
                                                <svg
                                                    height="100%"
                                                    viewBox="0 0 512 512"
                                                    width="100%"
                                                    className="fill-primary"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    id="fi_3710370"
                                                >
                                                    <g id="Navigator">
                                                        <path d="m456.59 74.3682a86.939 86.939 0 0 0 -132.2211 112.0053l56.8331 79.5625a17.1 17.1 0 0 0 27.832 0l56.833-79.5625a86.6665 86.6665 0 0 0 -9.277-112.0053zm-61.472 89.9763a28.5 28.5 0 1 1 28.5-28.5 28.5014 28.5014 0 0 1 -28.5 28.5z"></path>
                                                        <path d="m395.118 314.9019a17.0965 17.0965 0 0 0 -17.098 17.0981v36.46a60.4419 60.4419 0 1 1 -120.8838 0v-155.08a94.6382 94.6382 0 1 0 -189.2763 0v80.62a17.0982 17.0982 0 0 0 34.1963 0v-80.62a60.4419 60.4419 0 1 1 120.8837 0v155.08a94.6382 94.6382 0 0 0 189.2764 0v-36.46a17.0965 17.0965 0 0 0 -17.0983-17.0981z"></path>
                                                        <path d="m84.9578 352.9019a55.0981 55.0981 0 1 0 55.0982 55.0981 55.1578 55.1578 0 0 0 -55.0982-55.0981z"></path>
                                                    </g>
                                                </svg>
                                            </div>
                                            <span
                                                aria-hidden="true"
                                                className="absolute inset-0 rounded-lg shadow-inner"
                                            />
                                        </div>
                                    </div>
                                    <div className="pt-1.5">
                                        <div className="flex items-center gap-2">
                                            <h1 className="text-2xl font-bold text-gray-900">{tripInfo?.trip_name?.en}</h1>
                                            {tripInfo?.is_trip_private && (
                                                <Badge color="rose">{t('Private')}</Badge>
                                            )}
                                        </div>
                                        <p className="text-sm font-medium text-gray-500">
                                            {t('Waypoints')}
                                            <span className="text-primary"> {tripInfo?.schedule?.length}</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="mt-6 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-3 sm:space-y-0 sm:space-x-reverse md:mt-0 md:flex-row md:space-x-3">
                                    <a
                                        href={`/metro-trips/metro-trip-form/${tripInfo?.route_id}/${tripInfo?.trip_id}`}
                                        className="hover:bg-primary/[.9] bg-primary focus-visible:outline-primary inline-flex justify-center rounded-md px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                                    >
                                        {t('Edit Trip')}
                                    </a>
                                </div>
                            </div>

                            <div className="mt-8">
                                <div className="mt-3 border-t border-gray-100">
                                    <dl className="divide-y divide-gray-100">
                                        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Trip Name (EN)')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {tripInfo?.trip_name?.en}
                                            </dd>
                                        </div>
                                        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Trip Name (AR)')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {tripInfo?.trip_name?.ar}
                                            </dd>
                                        </div>
                                        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Trip Time')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {customTimeFormat(tripInfo?.start_time)} {t('to')}{' '}
                                                {customTimeFormat(tripInfo?.end_time)}
                                            </dd>
                                        </div>

                                        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Status')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {tripInfo?.status?.description?.en}
                                            </dd>
                                        </div>
                                        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Valid From')}- {t('Valid To')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                {customDateFormat(tripInfo?.valid_from)} {t('to')}{' '}
                                                {customDateFormat(tripInfo?.valid_to)}
                                            </dd>
                                        </div>

                                        {/* Trip Policy Settings Section */}
                                        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Trip Policy Settings')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                <div className="flex flex-wrap gap-4">
                                                    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                                                        tripInfo?.daypass_allowed 
                                                            ? 'bg-green-100 text-green-800' 
                                                            : 'bg-gray-100 text-gray-800'
                                                    }`}>
                                                        {t('Day Pass Allowed')}: {tripInfo?.daypass_allowed ? t('Yes') : t('No')}
                                                    </span>
                                                    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                                                        tripInfo?.reschedule_allowed 
                                                            ? 'bg-green-100 text-green-800' 
                                                            : 'bg-gray-100 text-gray-800'
                                                    }`}>
                                                        {t('Reschedule Allowed')}: {tripInfo?.reschedule_allowed ? t('Yes') : t('No')}
                                                    </span>
                                                </div>
                                            </dd>
                                        </div>
                                        {tripInfo?.return_trip_policy && (
                                            <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                <dt className="text-sm font-medium leading-6 text-gray-900">
                                                    {t('Return Trip Policy')}
                                                </dt>
                                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                    {tripInfo?.return_trip_policy?.description?.en || tripInfo?.return_trip_policy?.code}
                                                </dd>
                                            </div>
                                        )}

                                        {/* Audit Information */}
                                        {tripInfo?.user_audit && (
                                            <>
                                                <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                    <dt className="text-sm font-medium leading-6 text-gray-900">
                                                        {t('Created On')}
                                                    </dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {tripInfo.user_audit.created_date ? customDateFormat(tripInfo.user_audit.created_date) : 'N/A'}
                                                    </dd>
                                                </div>
                                                <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                    <dt className="text-sm font-medium leading-6 text-gray-900">
                                                        {t('Created By')}
                                                    </dt>
                                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                        {tripInfo.user_audit.created_by || 'N/A'}
                                                    </dd>
                                                </div>
                                                {tripInfo.user_audit.modified_date && (
                                                    <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Updated On')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {customDateFormat(tripInfo.user_audit.modified_date)}
                                                        </dd>
                                                    </div>
                                                )}
                                                {tripInfo.user_audit.modified_by && (
                                                    <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                        <dt className="text-sm font-medium leading-6 text-gray-900">
                                                            {t('Updated By')}
                                                        </dt>
                                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                            {tripInfo.user_audit.modified_by}
                                                        </dd>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        <div className="bg-white px-0 py-6 sm:grid sm:grid-cols-3 sm:gap-0 sm:px-3">
                                            <dt className="text-sm font-medium leading-6 text-gray-900">
                                                {t('Trip Timings')}
                                            </dt>
                                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 flex flex-col gap-4">
                                                {tripInfo?.schedule?.map((waypoint, index) => (
                                                    <>
                                                        <div className="border">
                                                            <div className="sm:col-span-full flex gap-1 items-center p-4">
                                                                <span className="circle-background bg-primary text-white">
                                                                    {waypoint?.stop_number}
                                                                </span>
                                                                <div>
                                                                    <p className="text-xs">
                                                                        {index === 0
                                                                            ? 'Trip Start'
                                                                            : index === tripInfo?.schedule.length - 1
                                                                            ? 'Trip End'
                                                                            : 'Stop'}
                                                                    </p>
                                                                    <h2 className="sm:col-span-full text-base font-semibold text-gray-900">
                                                                        {waypoint?.location?.name?.en}
                                                                    </h2>
                                                                </div>
                                                            </div>
                                                            <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                                <dt className="text-sm font-medium leading-6 text-gray-900">
                                                                    {t('Arrival Time')}
                                                                </dt>
                                                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                                    {/* {waypoint?.arrival_time ? moment(waypoint?.arrival_time, 'HH:mm:ss').format('hh:mm A') : ''} */}
                                                                    {customTimeFormat(waypoint?.arrival_time)}
                                                                </dd>
                                                            </div>
                                                            <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                                <dt className="text-sm font-medium leading-6 text-gray-900">
                                                                    {t('Departure Time')}
                                                                </dt>
                                                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                                    {/* {waypoint?.departure_time ? moment(waypoint?.departure_time, 'HH:mm:ss').format('hh:mm A') : ''} */}
                                                                    {customTimeFormat(waypoint?.departure_time)}
                                                                </dd>
                                                            </div>
                                                            <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                                <dt className="text-sm font-medium leading-6 text-gray-900">
                                                                    {t('Remarks')}
                                                                </dt>
                                                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                                    {waypoint?.remarks}
                                                                </dd>
                                                            </div>
                                                            {/* Waypoint Restrictions */}
                                                            <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-3">
                                                                <dt className="text-sm font-medium leading-6 text-gray-900">
                                                                    {t('Waypoint Restrictions')}
                                                                </dt>
                                                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                                                    <div className="flex flex-wrap gap-3">
                                                                        <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                                                                            waypoint?.entry_allowed 
                                                                                ? 'bg-blue-100 text-blue-800' 
                                                                                : 'bg-gray-100 text-gray-500'
                                                                        }`}>
                                                                            {t('Pickup Point')}: {waypoint?.entry_allowed ? t('Yes') : t('No')}
                                                                        </span>
                                                                        <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                                                                            waypoint?.exit_allowed 
                                                                                ? 'bg-purple-100 text-purple-800' 
                                                                                : 'bg-gray-100 text-gray-500'
                                                                        }`}>
                                                                            {t('Drop Point')}: {waypoint?.exit_allowed ? t('Yes') : t('No')}
                                                                        </span>
                                                                        <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                                                                            waypoint?.stop_chargeable 
                                                                                ? 'bg-amber-100 text-amber-800' 
                                                                                : 'bg-gray-100 text-gray-500'
                                                                        }`}>
                                                                            {t('Stop Chargeable')}: {waypoint?.stop_chargeable ? t('Yes') : t('No')}
                                                                        </span>
                                                                    </div>
                                                                </dd>
                                                            </div>
                                                        </div>

                                                        {index !== tripInfo?.schedule.length - 1 && (
                                                            <div className="relative sm:col-span-full">
                                                                <div
                                                                    aria-hidden="true"
                                                                    className="absolute inset-0 flex items-center"
                                                                >
                                                                    <div className="w-full border-t border-gray-200" />
                                                                </div>
                                                                <div className="relative flex justify-center text-sm font-medium leading-6">
                                                                    <span className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-full bg-white text-primary">
                                                                        <ArrowDownIcon
                                                                            aria-hidden="true"
                                                                            className="-ml-0.5 h-5 w-5"
                                                                        />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}
                                            </dd>
                                        </div>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}
